import { LinkButton } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { Logo } from "@/components/ui/Logo";
import { EmptyState } from "@/components/ui/States";
import { PublicLayout } from "@/components/layout/PublicLayout";

export function NotFoundPage() {
  return (
    <PublicLayout>
      <div className="w-full max-w-[480px] animate-fade-in">
        <Logo size="md" showTagline />
        <Card padding="lg" className="mt-8">
          <EmptyState
            icon="🔎"
            title="Page not found"
            description="The page you're looking for doesn't exist — check the link or head back home."
            action={<LinkButton to="/">Back to home</LinkButton>}
          />
        </Card>
      </div>
    </PublicLayout>
  );
}
